<template>
	<div class="allchain">
		<leftnav class="fl" mkcode="R"
			:itemcode="yj_itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title">研究报告</span>
						<span class="fl dib py-1 ml-5 orgfont">全库 1000+份 深度行业研究报告，研究行业再也不用自己查找整合资料，直接看就行！省时！省力！</span>
						<!-- <div class="fr search-box nz-search-box">
							<span class="searchtype">产业图谱库</span>
							<input type="text" placeholder="请输入产业关键词" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div> -->
					</div>
					<div class="opport-screen-list1">
						<dl class="opport-screen bdbe">
							<dt class="fl">一级行业</dt>
							<dd class="fl">
								<span :class="industryValue == 0 ? 'a-screen current' : 'a-screen'"
									@click="chooseIndutry({paraValue:0,paraName:'全部'},1)">全部</span>
									
									<span :class="industryValue == list.value ? 'a-screen current' : 'a-screen'"
									@click="chooseFuture(list, 1)" :key="'future'+i" v-for="(list, i) in futureList">{{
										list.name }}</span>
								<span :class="industryValue == list.paraValue ? 'a-screen current' : 'a-screen'"
									@click="chooseIndutry(list, 1)" :key="i" v-for="(list, i) in industryList">{{
										list.paraName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="industryList2.length > 0">
							<dt class="fl">二级行业</dt>
							<dd class="fl">
								<span :class="industryValue2 == 0 ? 'a-screen current' : 'a-screen'" v-show="industryValue != 'w0'"
									@click="chooseIndutry({paraValue:0,paraName:'全部'}, 2)">全部</span>
								<span :class="industryValue2 == list.paraValue ? 'a-screen current' : 'a-screen'" v-show="industryValue != 'w0'"
									@click="chooseIndutry(list, 2)" :key="i" v-for="(list, i) in industryList2">{{
										list.paraName }}</span>
								<span :class="industryValue2 == list.value ? 'a-screen current' : 'a-screen'" v-show="industryValue == 'w0'"
									@click="chooseFuture(list, 2)" :key="'future_'+i" v-for="(list, i) in industryList2">{{
										list.name }}</span>
							</dd>
						</dl>
					</div>
				</div>
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" >产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
					</div>
					<div class="">
						<ul class="margin-x-auto widthPC-95 oh">
							<li class="report_li" v-for="(list, i) in reportList" :key="i" @click="routerblank('/reportDetail?id='+list.id)">
								<div class="img-box"><img :src="list.image" /></div>
								<div>
									<h4 class="title">{{ list.title }}</h4>
									<p class="indu_date smfont">最新修订：{{ list.reviseDate }} </p>
									<p class="indu_date smfont">报告属性：共{{ list.wordCount }} 万字、{{ list.chartCount }} 个图表
									</p>
								</div>
							</li>
						</ul>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
	name: 'allchain',
	computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "报告库",
			curWebsite: this.$api.getWebsiteType(),
			userdata: {},
			reportList: [],
			industryList: [],
			industryList2: [],
			industryValue: 10005,
			industryValue2: 0,
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
			isShowFreeUserTips:false,
			yj_itemcode:'R-BGQK',
			biglist: [{
						name: "未来产业",
						value: 'w0', 
						itemcode:"R-WLCY",
					},
					{
						name: "数字经济",
						value: 10005, 
						itemcode:"R-SZJJ",
					},
					{
						name: "高端制造",
						value: 10014,
						itemcode:"R-GDZZ",
					},
					{
						name: "能源环保材料",
						value: 10024,
						itemcode:"R-NYHBCL",
					},
					{
						name: "现代服务业",
						value: 10018,
						itemcode:"R-XDFWY",
					},
					{
						name: "大消费",
						value: 10029,
						itemcode:"R-DXF",
					},
					
					{
						name: "基建与投资",
						value: 10034,
						itemcode:"R-JJYTZ",
					},
					{
						name: "大健康",
						value: 10001,
						itemcode:"R-DJK",
					},
					{
						name: "报告全库",
						value: 0,
						itemcode:"R-BGQK",
					},
					{
						name: "月度报告",
						value: 10055,
						itemcode:"R-YDBG",
					},
					
				],
			futureList:[],
		}
	},
	watch: {
				$route: function (newVal,oldVal) { 
					// console.log(newVal); 
						if(this.$route.query.type){
							let quertyType=this.$route.query.type;
							this.industryValue=quertyType?quertyType:'w0';
							console.log('检测路由变化',this.industryValue);
							//当前菜单做对比，给当前页面左侧菜单高亮
							this.validity();
							 
						} 
				}
		}, 
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.industryValue = this.$route.query.type || 'w0';
		this.biglist.forEach(item=>{
					 if(this.industryValue == item.value){
						this.yj_itemcode=item.itemcode;
						document.title = item.name;
						}
				});
		// this.userdata = this.getuseriformation();
		this.getparameterList();
		
	},
	mounted() { },
	methods: {
		//
		validity(){
		if(this.industryValue == 'w0'){
				this.chooseFuture(this.futureList[0],1);
				this.chooseFuture(this.futureList[0].children[0],2);
			}else{
				for(let i= 0; i < this.industryList.length; i++){
				let item = this.industryList[i];
				if(this.industryValue == item.paraValue){
					// console.log(item);
					this.chooseIndutry(item, 1);
						continue;
					}else if(this.industryValue == 0) {
					this.chooseIndutry({paraName:'全库',paraValue:0}, 1);
					continue;
					}
			}
			}
		},
		chooseFuture(list,step){
			console.log(list,step);
			if(step == 1){
				this.yj_itemcode = list.itemcode;
				this.industryValue = list.value;
				this.industryList2 = list.children;
				this.chooseFuture(list.children[0],2);
				// document.title = list.name;
			}else {
				this.industryValue2 = list.value;
				this.reportList = list.reportList;
			}
			this.total = this.reportList.length;
			// console.log(this.industryList2,this.industryValue);
		},
		//获取未来产业参数及列表，参数用的列表里面的一级name
		getFutureList() {
			var _this = this;
			var ajaxurl = this.$api.free.report.futureIndustry();
			this.bus.$emit('loading', true);
			this.$axios.get(ajaxurl).then(function (res) {
				if (res.data.success) {
					let data = res.data.list;
					let list = {name:'未来产业',value:'w0',itemcode:'R-WLCY',children:data};
					_this.futureList.push(list);
					console.log('未来产业',_this.futureList);
					if(_this.industryValue == 'w0'){
					_this.chooseFuture(list,1);

					}
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		chooseIndutry(list,step) {
			if(step == 1){
				//当前菜单做对比，给当前页面左侧菜单高亮
				this.biglist.forEach(item=>{
					 if(list.paraValue == item.value){
						this.yj_itemcode=item.itemcode;
						}
				});
				if(list.paraValue == 0){
					this.industryValue = 0;
					this.industryValue2 =0;
					this.industryList2=[];
					console.log(list);
				}else {
					this.industryValue = list.paraValue;
					this.industryList2 = list.children;
					this.industryValue2 = '';
				}
			}else if(step == 2){
				this.industryValue2 = list.paraValue;
			}
			this.getList();
		},
		getparameterList(value) {
			var _this = this;
			var ajaxurl = this.$api.free.report.industryList();
			this.$axios.get(ajaxurl).then(function (res) {
				if (res.data.success) {
					console.log('行业参数', res);
					let industry = res.data.list;
					// 根据 biglist 中的 name 顺序，重新排列 industry,Sam说要按照左侧菜单栏排序
					const sortedList = _this.biglist.map(item => {
						return industry.find(node => node.paraName === item.name);
					}).filter(item => item !== undefined);
					_this.industryList = sortedList;
					console.log('排序后',sortedList);
					_this.getFutureList();
					_this.validity();
					// if(_this.industryList.length>0){
					// 	_this.chooseIndutry(_this.industryList[0], 1);
					// }
				_this.getList();
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		getList(pages) {
			var _this = this;
			this.page = pages ? pages : 1;
			this.bus.$emit('loading', true);
			var ajaxurl = this.$api.free.report.list() + '?page=' + this.page + '&industry1=' + this.industryValue + '&industry2=' + this.industryValue2;
			this.$axios.get(ajaxurl).then(function (res) {
				if (res.data.success) {
					console.log('报告列表', res, ajaxurl);
					_this.reportList = res.data.list;
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				_this.bus.$emit('loading', false);
				// 请求失败处理 console.log(error);
			});
		},
		pageHandler: function (page) {
			if(page>1){
				this.isShowFreeUserTips = true;
				return;
			}
			this.getList(page);
		},

	},
}
</script>

<style lang="scss">
.report_li {
	width: calc(32% - 60px);
	border: 1px solid rgb(231, 231, 231);
	border-radius: 4px;
	box-shadow: 2px 3px 5px 1px rgb(231, 231, 231);
	height: 130px;
	padding: 20px 10px;
	float: left;
	margin: 20px;
	&:hover{
		scale: 1.05;
		cursor: pointer;
		transition: all 0.3s;
		.title{
			color: #5E83CC;
		}
	}
	.img-box {
		width: 86px;
		height: 126px;
		float: left;
		margin-right: 10px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.title {
		padding-top: 5px;
		height: 48px;
		line-height: 24px;
		text-overflow: ellipsis;
		overflow: hidden;
		font-size: 16px;
		padding-bottom: 5px;
	}

	.smfont {
		color: #707070;
		font-size: 14px;
	}
}
</style>